
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { UserAddAvatarComponent } from '../../../atoms/user-add-avatar/user-add-avatar.component';
import { UserAvatarComponent } from '../../../atoms/user-avatar/user-avatar.component';
import { UserListInterface } from '../../models/interfaces/user-list.model';
import { UserModel } from '../../models/interfaces/user.model';
import { CerrixDialogService } from '../../services/cerrix-dialog.service';
import { CerrixDialogInterface } from '../../models/dialog/cerrix-dialog.model';
import { CerrixStaffingComponent } from '../cerrix-staffing.component';

@Component({
    selector: 'cerrix-avatar-group',
    imports: [
    MatIconModule,
    MatTooltip,
    UserAvatarComponent,
    UserAddAvatarComponent
],
    templateUrl: './cerrix-avatar-group.component.html',
    styleUrl: './cerrix-avatar-group.component.scss',
    providers: [CerrixDialogService]
})
export class CerrixAvatarGroupComponent {
  @Input() public userLists: UserListInterface[] = [];
  @Output() public userListsChange: EventEmitter<UserListInterface[]> =
    new EventEmitter();
  @Input() public selectedPermissionIndex: number = 0;
  @Input() public rolePermissionSelection: boolean = false;
  @Input() public editable: boolean = false;
  @Input() public disableTooltip: boolean = false;
  @Input() public dataUiid: string = 'undefined';

  private _userLists: UserListInterface[] = [];
  private _dialogService = inject(CerrixDialogService);

  getAllUsers(): UserModel[] {
    let users: UserModel[] = [];
    this.userLists.forEach(x => {
      users.push(
        ...x.selectableUsers.filter(user => x.users.includes(user.id))
      );
    });
    return users;
  }

  hasMessages(): boolean {
    return this.userLists.some(
      list => list.messages !== undefined && list.messages.length > 0
    );
  }

  getMessageTypes(): string[] {
    let classList: string[] = [];
    this.userLists.forEach(list => {
      if (list.messages !== undefined) {
        list.messages.forEach(message => {
          if (message.type !== undefined && !classList.includes(message.type)) {
            classList.push(message.type);
          }
        });
      }
    });
    return classList;
  }

  cloneLists(originaLists: UserListInterface[]): UserListInterface[] {
    return JSON.parse(JSON.stringify(originaLists));
  }

  openStaffingPopup(): void {
    this._userLists = this.cloneLists(this.userLists);
    this._userLists.forEach(list => {
      list.selectableUsers = list.selectableUsers.filter(
        user => user.deleted === false || list.users.includes(user.id)
      );
    });
    let popupData: CerrixDialogInterface = {
      promptUiid: `${this.dataUiid}-assign-users`,
      maxWidth: false,
      title: 'Assigned users',
      component: CerrixStaffingComponent,
      componentData: {
        dataUiid: `${this.dataUiid}-assign-users-dialog`,
        userLists: this._userLists,
        selectedPermissionIndex: this.selectedPermissionIndex,
        rolePermissionSelection: this.rolePermissionSelection,
        editable: this.editable,
      },
    };

    if (this.editable) {
      this._dialogService.openDialog({
        data: {
          ...popupData,
          positiveButton: {
            text: 'Apply changes',
            buttonClass: 'positive',
            onAction: () => {
              this.userListsChange.emit(this._userLists);
              return true;
            },
          },
          negativeButton: {
            text: 'Cancel',
            buttonClass: 'cancel',
            onAction: () => {
              return true;
            },
          },
        },
      });
    } else {
      this._dialogService.openDialog({
        data: {
          ...popupData,
          negativeButton: {
            text: 'Close',
            buttonClass: 'cancel',
            onAction: () => {
              return true;
            },
          },
        },
      });
    }
  }
}
